import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { ReverseReleasedItemService } from '../../services/wealthlane-award-services/services/ReverseReleasedItemService';

const useDeleteEmptyRelease = (
    handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
    onClose?: () => void
): UseMutationResult<any, unknown, string, unknown> => {
    const queryClient = useQueryClient();

    return useMutation(
        async (releaseId: string) => {
            return await handleRequest(
                ReverseReleasedItemService.deleteApiAwardApiAppReverseReleasedItemEmptyRelease(releaseId)
            );
        },
        {
            onSuccess: async (response: any) => {
                onClose && onClose();
                if (response !== null && response?.isSuccess) {
                    toast.success(
                        <ToastComponent label='Success' message={`${String(response?.message)}`} />
                    );
                    await queryClient.invalidateQueries('getTransactionsReleaseList');
                } else {
                    toast.error(
                        <ToastComponent
                            label='Error'
                            message={`${String(response?.message ?? 'Failed to delete empty release')}`}
                        />,
                        { autoClose: false }
                    );
                }
            },
            onError: (err: any) => {
                onClose && onClose();
                console.log('error', err);
            },
        }
    );
};

export default useDeleteEmptyRelease;

